import { PieChart } from "@mui/x-charts/PieChart";
import { BarChart } from "@mui/x-charts/BarChart";
import { LineChart } from "@mui/x-charts/LineChart";
import { Box, Card, CardContent, Typography, Tooltip, IconButton } from "@mui/material";
import { lightBlue, deepPurple, teal, red } from "@mui/material/colors";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

export const SECTION_LABELS = (t) => ({
	Diurno: t("shifts.diurno"),
	Nocturno: t("shifts.nocturno"),
	Madrugada: t("shifts.madrugada"),
});

const barColors = {
	Diurno: {
		sp: "#009957",
		real: "#66BFFF",
		diferencia: "#FFA166",
	},
	Nocturno: {
		sp: "#009957",
		real: "#66BFFF",
		diferencia: "#FFA166",
	},
	Madrugada: {
		sp: "#009957",
		real: "#66BFFF",
		diferencia: "#FFA166",
	},
};

const baseColors = {
	BS: "primary",
	Diurno: teal[700],
	Nocturno: lightBlue[700],
	Madrugada: deepPurple[700],
};

function PieChartNE({ data, cargando, t }) {
	const filteredData = data.filter((item) => item.valor > 0);
	const labels = SECTION_LABELS(t);

	return (
		<Box sx={{ width: "100%", height: "100%" }}>
			{cargando ? (
				<Typography variant="h6" align="center">
					{t("new_charts.loading_data")}
				</Typography>
			) : filteredData.length > 0 ? (
				<PieChart
					margin={{ top: 30 }}
					series={[
						{
							data: filteredData.map((item) => ({
								id: item.seccion,
								value: item.valor,
								label: labels[item.seccion],
								color: baseColors[item.seccion],
							})),
							arcLabel: (params) => (params.value !== undefined ? String(params.value) : ""),
							arcLabelMinAngle: 20,
							innerRadius: 50,
							paddingAngle: 2,
							cornerRadius: 3,
						},
					]}
					slotProps={{
						legend: {
							direction: "column",
							position: { vertical: "top", horizontal: "right" },
							padding: 20,
						},
					}}
				/>
			) : (
				<Typography variant="h6" align="center">
					{t("new_charts.no_data")}
				</Typography>
			)}
		</Box>
	);
}

function PieChartSP({ data, cargando, t }) {
	const filteredData = data.filter((item) => item.valor > 0);
	const labels = SECTION_LABELS(t);

	return (
		<Box sx={{ width: "100%", height: "100%", position: "relative" }}>
			{/* <Tooltip
				arrow
				placement="left"
				title={
					<Typography variant="body2">
						{t("new_charts.contractsDistributionTooltip.description")}
					</Typography>
				}
			>
				<IconButton
					size="small"
					sx={{
						position: "absolute",
						top: 0,
						right: 0,
						border: "1px solid",
						borderColor: "divider",
						width: 24,
						height: 24,
						zIndex: 1,
					}}
				>
					<InfoOutlinedIcon fontSize="small" />
				</IconButton>
			</Tooltip> */}

			{cargando ? (
				<Typography variant="h6" align="center">
					{t("new_charts.loading_data")}
				</Typography>
			) : filteredData.length > 0 ? (
				<PieChart
					margin={{ top: 30 }}
					series={[
						{
							data: filteredData.map((item) => ({
								id: item.seccion,
								value: item.valor,
								label: labels[item.seccion],
								color: baseColors[item.seccion],
							})),
							arcLabel: (params) => (params.value !== undefined ? String(params.value) : ""),
							arcLabelMinAngle: 20,
							innerRadius: 50,
							paddingAngle: 2,
							cornerRadius: 3,
						},
					]}
					slotProps={{
						legend: {
							direction: "column",
							position: { vertical: "top", horizontal: "right" },
							padding: 20,
						},
					}}
				/>
			) : (
				<Typography variant="h6" align="center">
					{t("new_charts.no_data")}
				</Typography>
			)}
		</Box>
	);
}

function BarCharts({ data = [], seccion, cargando, t }) {
	return (
		<Box sx={{ width: "100%", height: "100%" }}>
			{cargando ? (
				<Typography variant="h6" align="center">
					{t("new_charts.loading_data")} {seccion}...
				</Typography>
			) : data.length > 0 ? (
				<BarChart
					barLabel="value"
					borderRadius={3}
					slotProps={{
						loadingOverlay: { message: "Data should be available soon." },
						legend: {
							direction: "row",
							position: { vertical: "bottom", horizontal: "middle" },
							padding: { top: -5 },
							itemMarkWidth: 10,
							itemMarkHeight: 10,
							markGap: 5,
							itemGap: 6,
						},
					}}
					xAxis={[{ scaleType: "band", data: data.map((item) => item.nombre) }]}
					series={[
						{
							data: data.map((item) => item.contratados_sp),
							label: t("new_charts.staffing_sp"),
							color: barColors[seccion].sp,
						},
						{
							data: data.map((item) => item.contratados_ne),
							label: t("new_charts.staffing_real"),
							color: barColors[seccion].real,
						},
						{
							data: data.map((item) => item.diferencia),
							label: t("new_charts.diferent"),
							color: barColors[seccion].diferencia,
						},
					]}
				/>
			) : (
				<Typography variant="h6" align="center">
					{t("new_charts.no_data")} {seccion}
				</Typography>
			)}
		</Box>
	);
}

function LineCharts({ data = [], t }) {
	return (
		<Box sx={{ width: "100%", height: "100%" }}>
			{data.length > 0 ? (
				<LineChart
					xAxis={[
						{
							scaleType: "band",
							data: data.map((item) => item.fecha),
							label: t("aux.date"),
							valueFormatter: (value) => {
								const fecha = new Date(value);
								const mesDia = fecha.toLocaleDateString("es-ES", {
									month: "2-digit",
									day: "2-digit",
								});
								const ano = fecha.getFullYear();
								return `${mesDia}\n${ano}`;
							},
						},
					]}
					yAxis={[
						{
							label: t("new_charts.promedio_coverage"),
						},
					]}
					grid={{ horizontal: true }}
					series={[
						{
							data: data.map((item) => item.cobertura),
							label: t("new_charts.promedio_coverage"),
						},
					]}
					slotProps={{
						loadingOverlay: { message: t("aux.loading") },
						legend: {
							direction: "row",
							position: { vertical: "top", horizontal: "middle" },
							padding: { top: -5 },
							itemMarkWidth: 10,
							itemMarkHeight: 10,
							markGap: 5,
							itemGap: 6,
						},
					}}
				/>
			) : (
				<p>{t("new_charts.no_data")}</p>
			)}
		</Box>
	);
}

function Tarjeta({ titulo, valor, cargando, t }) {
	return (
		<Box>
			<Card sx={{ mt: 2, textAlign: "center", height: "12vh", width: "100%" }}>
				<CardContent>
					<Typography variant="h6" component="div">
						{titulo}
					</Typography>
					<Typography variant="h5" sx={{ fontSize: "1rem", fontWeight: 400 }}>
						{cargando ? t("new_charts.loading") : valor !== null ? valor : t("new_charts.no_data")}
					</Typography>
				</CardContent>
			</Card>
		</Box>
	);
}

function TarjetaDiferencia({ titulo, diferencia, seccion, cargando, t }) {
	const valor = parseFloat(diferencia);
	const isFaltante = !isNaN(valor) && valor < 0; // NE - SP < 0 => faltan personas
	const colorTexto = isFaltante ? red[600] : baseColors[seccion];

	return (
		<Box>
			<Card
				variant="outlined"
				sx={{
					mt: 2,
					textAlign: "center",
					height: "12vh",
					mb: 2,

					borderRadius: "16px",
					border: "1px solid",
					borderColor: "divider",
				}}
			>
				<CardContent>
					<Box
						sx={{
							display: "flex",
							alignItems: "center",
							justifyContent: "center",
							gap: 1,
							mb: 1,
						}}
					>
						<Typography variant="h6" component="div">
							{titulo}
						</Typography>

						{/* <Tooltip
							arrow
							placement="bottom"
							title={
								<Box>
									<Typography variant="body2" sx={{ mb: 1 }}>
										{t("new_charts.contractsDifferenceTooltip.kpiDescription")}
									</Typography>

									<Typography variant="body2">
										<Box component="span" sx={{ fontWeight: 700 }}>
											{t("new_charts.contractsDifferenceTooltip.deficitTitle")}
										</Box>{" "}
										{t("new_charts.contractsDifferenceTooltip.deficitDescription")}
									</Typography>

									<Typography variant="body2">
										<Box component="span" sx={{ fontWeight: 700 }}>
											{t("new_charts.contractsDifferenceTooltip.excessTitle")}
										</Box>{" "}
										{t("new_charts.contractsDifferenceTooltip.excessDescription")}
									</Typography>
								</Box>
							}
						>
							<IconButton
								size="small"
								sx={{
									border: "1px solid",
									borderColor: "divider",
									width: 24,
									height: 24,
								}}
							>
								<InfoOutlinedIcon fontSize="small" />
							</IconButton>
						</Tooltip> */}
					</Box>

					<Typography
						variant="h5"
						color={colorTexto}
						sx={
							diferencia === t("new_charts.no_data")
								? { fontSize: "1rem", fontWeight: isFaltante ? 600 : 400 }
								: {}
						}
					>
						{cargando
							? t("new_charts.loading")
							: diferencia !== null
							? diferencia
							: t("new_charts.no_data")}
					</Typography>
				</CardContent>
			</Card>
		</Box>
	);
}

function TarjetaLogrado({ titulo, diferencia, logrado, seccion, cargando, t }) {
	const valDiff = parseFloat(diferencia);
	const diffIsFaltante = !isNaN(valDiff) && valDiff < 0;
	const diffColor = diffIsFaltante ? red[600] : baseColors[seccion];
	const diffContent = cargando
		? t("new_charts.loading")
		: diferencia !== null
		? `${t("new_charts.diferent")}: ${diferencia}`
		: t("new_charts.no_data");

	const shrinkFont = diferencia === t("new_charts.no_data");
	const commonFontSize = shrinkFont ? "0.9rem" : "inherit";

	return (
		<Box>
			<Card
				variant="outlined"
				sx={
					logrado && diferencia === t("new_charts.no_data")
						? {
								textAlign: "center",
								height: "17vh",
								borderRadius: "16px",
								border: "1px solid",
								borderColor: "divider",
						  }
						: {
								textAlign: "center",
								borderRadius: "16px",
								border: "1px solid",
								borderColor: "divider",
						  }
				}
			>
				<CardContent>
					<Typography variant="h6" component="div">
						{t("shifts.shift")} {titulo}
					</Typography>
					<Typography
						color={diffColor}
						sx={diferencia === t("new_charts.no_data") ? { fontSize: commonFontSize } : {}}
						variant="h6"
						component="div"
					>
						{diffContent}
					</Typography>
					<Typography
						variant="h6"
						color={baseColors[seccion]}
						sx={logrado === t("new_charts.no_data") ? { fontSize: commonFontSize } : {}}
					>
						{cargando
							? t("new_charts.loading")
							: logrado !== null
							? `${t("new_charts.achieved")}: ${logrado}`
							: t("new_charts.no_data")}
					</Typography>
				</CardContent>
			</Card>
		</Box>
	);
}

export {
	PieChartNE,
	PieChartSP,
	BarCharts,
	LineCharts,
	TarjetaDiferencia,
	TarjetaLogrado,
	Tarjeta,
};
